import {
  askIcon,
  calendarIcon,
  instantIcon,
  jobIcon,
  searchIcon,
} from "../../images";
import {
  accountCategoryURL,
  registrationBusinessURL,
} from "../helpers/constant-words";

export const businessData = {
  BO: {
    proFeatures: [
      {
        icon: searchIcon,
        desc: "Search for People & Products in the design industry",
      },
      {
        icon: instantIcon,
        desc: "Instantly Connect on Demand within Industry",
      },
      {
        icon: calendarIcon,
        desc: "Stay updated on Art &<br />Design events near you",
      },
    ],
  },
  ST: {
    proFeatures: [
      {
        icon: askIcon,
        desc: "Ask anything to Design & Build",
      },
      {
        icon: searchIcon,
        desc: "Search for People and Products in the design industry",
      },
      {
        icon: jobIcon,
        desc: "Search for Jobs &<br />Internships",
      },
      {
        icon: calendarIcon,
        desc: "Stay updated on Art &<br />Design events near you",
      },
    ],
  },
  DE: {
    proFeatures: [
      {
        icon: askIcon,
        desc: "Ask anything to Design & Build",
      },
      {
        icon: searchIcon,
        desc: "Search for People and Products in the design industry",
      },
      {
        icon: calendarIcon,
        desc: "Stay updated on Art &<br />Design events near you",
      },
    ],
  },
  TM: {
    proFeatures: [
      {
        icon: askIcon,
        desc: "Ask anything to Design & Build",
      },
      {
        icon: searchIcon,
        desc: "Search for People and Products in the design industry",
      },
      {
        icon: jobIcon,
        desc: "Search for Jobs &<br />Internships",
      },
      {
        icon: calendarIcon,
        desc: "Stay updated on Art &<br />Design events near you",
      },
    ],
  },
};

export const STFAQData = [
  {
    title: "What is Archinza all about?",
    content:
      "Archinza is an AI-powered Design Assistant built for stakeholders across the Design & Build industry. Whether you have construction or design-related queries or need professional guidance, Archinza provides relevant, real-time answers. From sourcing products, materials, and services to expanding your reach and visibility, the platform helps you search smarter and connect with the right people.In addition, the platform enables personal users to access curated resources, stay updated on industry events, explore career and hiring opportunities, and review businesses and firms. Archinza also offers AI-matched upskilling courses making it a one-stop platform for knowledge, discovery, and growth.",
  },
  {
    title: `Who is Archinza for?`,
    content:
      "Archinza is designed for anyone seeking information or connections in the Design & Build industry. Whether you're a creative professional (designer, architect, content creator), a service provider (business owner, contractor, vendor, PR or marketing professional), a material or product seller/distributor, or simply someone passionate about the industry, Archinza is here to empower your journey at every stage.",
  },
  {
    title: `What is the "Ask" feature in Archinza?`,
    content: `<b>The Ask feature (available on Whatsapp) is powered by AI and provides instant, relevant answers to your queries about design, construction, and professional guidance.</b> In the currently available Beta version of Archinza, you can ask about technical details, materials suggestions, methods, project tips, or even mentorship. After the full product you will be able to matchmade recommendations for vendors / consultants / designers or execution teams. <div class="mt-2"> Please note: Archinza AI™  is a model in development, doing its best to provide helpful responses in real time and continuously learning to improve.</div>`,
  },
  {
    title: "Can I ask my design related queries on Archinza?",
    content:
      "Yes, you can. Archinza is designed to support your learning journey by answering a wide range of design and construction-related questions. Whether you're exploring materials, design methods, or technical details, you can simply use our <b>Ask</b>  feature on <b>WhatsApp</b> for instant, AI-powered responses. It’s quick, easy, and feels just like chatting with a mentor anytime you need help.",
  },
  {
    title: "Can I search for design materials or products on Archinza?",
    content:
      "Yes, you can. Archinza’s <b>Search</b> feature helps you explore a wide range of design materials, products, and vendors right from surfaces and fittings to lighting and finishes. Whether you're working on a college project or expanding your material knowledge, you can search using text or even upload an image to find visually similar options. It’s a great way to discover what’s out there and how professionals actually source and specify products. ",
  },
  {
    title: "How does Archinza help me find job opportunities or internships?",
    // content: `Archinza offers free access to its features for the first 500 users. <a href='${accountCategoryURL}' class='anchor'>Click here</a> to get free access to the Archinza Network.`,
    content: `Archinza connects you to real-time opportunities across the Design & Build industry ranging from internships and freelance gigs to full-time roles. With our <b>AI-based matchmaking</b>, you’re more likely to discover openings that match your skills, interests, and location. Plus, you’ll be visible to studios, professionals, and firms actively looking for emerging talent. It’s a smarter way to get discovered and start your career journey on the right foot.
`,
  },
  {
    title: "Is Archinza free? ",
    content: `Archinza is currently free for personal accounts during our limited early access phase available only until the full product launch. After that, subscription plans will range between ₹999 and ₹2999, depending on your account type and selected features.
`,
  },
];

export const TMFAQData = [
  {
    title: "What is Archinza all about?",
    content:
      "Archinza is an AI-powered Design Assistant built for stakeholders across the Design & Build industry. Whether you have construction or design-related queries or need professional guidance, Archinza provides relevant, real-time answers. From sourcing products, materials, and services to expanding your reach and visibility, the platform helps you search smarter and connect with the right people. In addition, the platform enables personal users to access curated resources, stay updated on industry events, explore career and hiring opportunities, and review businesses and firms. Archinza also offers AI-matched upskilling courses making it a one-stop platform for knowledge, discovery, and growth.",
  },
  {
    title: "Who is Archinza for?",
    content:
      "Archinza is designed for anyone seeking information or connections in the Design & Build industry. Whether you're a creative professional (designer, architect, content creator), a service provider (business owner, contractor, vendor, PR or marketing professional), a material or product seller/distributor, or simply someone passionate about the industry, Archinza is here to empower your journey at every stage.",
  },

  {
    title: `What is the "Ask" feature in Archinza?`,
    content: `<b>The Ask feature (available on Whatsapp) is powered by AI and provides instant, relevant answers to your queries about design, construction, and professional guidance.</b> In the currently available Beta version of Archinza, you can ask about technical details, materials suggestions, methods, project tips, or even mentorship. After the full product you will be able to matchmade recommendations for vendors / consultants / designers or execution teams. <div class="mt-2"> Please note: Archinza AI™  is a model in development, doing its best to provide helpful responses in real time and continuously learning to improve.</div>`,
  },
  {
    title: "Can I ask Archinza specific questions related to my work?",
    content: `Yes, you can. Archinza is designed to support professionals across the Design & Build ecosystem by providing quick, AI-powered answers to work-related queries. Whether you're dealing with material choices, detailing doubts, site execution methods, or project-specific decisions, the <b>Ask</b> feature on <b>WhatsApp</b> offers relevant, contextual guidance in real time and helps you move forward with clarity.
`,
  },
  {
    title: "How does Archinza help me find job opportunities?",
    // content: `Archinza offers free access to its features for the first 500 users. <a href='${accountCategoryURL}' class='anchor'>Click here</a> to get free access to the Archinza Network.`,
    content: `Archinza connects professionals with curated job openings, freelance projects, and collaborations across the Design & Build industry. Our <b>AI-powered matchmaking</b> ensures that you’re shown relevant opportunities based on your skills, experience, and interests. Whether you're looking to grow within a firm, take on independent work, or explore a new role, Archinza helps you stay visible and connected to the right circles.`,
  },
  {
    title: "Can I search for design materials or products on Archinza?",
    content: `Yes. Archinza’s <b>Search</b>  feature is built to help professionals discover a wide range of materials, products, and vendors across the Design & Build industry. You can use text input or even image-based search to find finishes, surfaces, fittings, lighting, and more. It’s a fast, intuitive way to explore / source options, compare choices, and stay updated with what’s new in the market.`,
  },
  {
    title: "Is Archinza free? ",
    content: `Archinza is currently free for personal accounts during our limited early access phase available only until the full product launch. After that, subscription plans will range between ₹999 and ₹2999, depending on your account type and selected features.`,
  },
];

export const BFOFAQData = [
  {
    title: "What is Archinza all about?",
    content:
      "Archinza is an AI-powered Design Assistant built for stakeholders across the Design & Build industry. Whether you have construction or design-related queries or need professional guidance, Archinza provides relevant, real-time answers. From sourcing products, materials, and services to expanding your reach and visibility, the platform helps you search smarter and connect with the right people. In addition, the platform enables personal users to access curated resources, stay updated on industry events, explore career and hiring opportunities, and review businesses and firms. Archinza also offers AI-matched upskilling courses making it a one-stop platform for knowledge, discovery, and growth.",
  },
  {
    title: "Who is Archinza for?",
    content:
      "Archinza is designed for anyone seeking information or connections in the Design & Build industry. Whether you're a creative professional (designer, architect, content creator), a service provider (business owner, contractor, vendor, PR or marketing professional), a material or product seller/distributor, or simply someone passionate about the industry, Archinza is here to empower your journey at every stage.",
  },

  {
    title: `What is the "Ask" feature in Archinza?`,
    content: `<b>The Ask feature (available on Whatsapp) is powered by AI and provides instant, relevant answers to your queries about design, construction, and professional guidance.</b> In the currently available Beta version of Archinza, you can ask about technical details, materials suggestions, methods, project tips, or even mentorship. After the full product you will be able to matchmade recommendations for vendors / consultants / designers or execution teams. <div class="mt-2"> Please note: Archinza AI™  is a model in development, doing its best to provide helpful responses in real time and continuously learning to improve.</div>`,
  },
  {
    title: `Will Archinza help me find clients?`,
    content: `Yes. Archinza is designed to help your business get discovered by those actively looking for the services or products you offer. Using <b>AI-based matchmaking</b>, the platform connects you based on your expertise, and profile. It’s a powerful way to increase visibility, attract quality leads, and build valuable partnerships without the need for constant outreach.`,
  },
  {
    title: "What are the benefits of registering my business on Archinza?",
    // content: `<a href='${accountCategoryURL}' class='anchor'>Click here</a> to get free access to the Archinza Network.<br/>Archinza offers free access to its features for the first 500 users.`,
    content: `Registering your business on Archinza enhances your visibility within the Design & Build ecosystem. It enables seamless discovery by potential clients, simplifies vendor sourcing and hiring, and offers a credible platform to showcase your services and portfolio. You also gain timely access to curated industry insights, design event updates, and valuable business resources helping you stay competitive, informed, and connected to new opportunities. <div class="mt-2"><a href='${registrationBusinessURL}' class='anchor'>Click here</a> to register your business with Archinza </div>`,
  },
  {
    title: "Is Archinza free? ",
    content: `Archinza is currently free for personal accounts during our limited early access phase available only until the full product launch. After that, subscription plans will range between ₹999 and ₹2999, depending on your account type and selected features.
    <div class="mt-2"><b>For Businesses</b></div>
    We're also offering exclusive free access to our first 1000 business users for the SILVER Plan features —no charges, no catches. Post that, business accounts will be available at ₹ 800- ₹2,500 per month until the full product rollout.
`,
  },
  {
    title: "How can I save time and reduce costs when using Archinza?",
    content: `Archinza helps business owners cut down on both time and overhead by simplifying everyday decisions be it sourcing vendors, resolving on-site queries, or finding the right professionals. With instant answers via the Ask feature and AI-led matchmaking for clients, collaborators, and products, you spend less time chasing leads or doing manual research.`,
  },
];

export const DEFAQData = [
  {
    title: "What is Archinza all about?",
    content:
      "Archinza is an AI-powered Design Assistant built for stakeholders across the Design & Build industry. Whether you have construction or design-related queries or need professional guidance, Archinza provides relevant, real-time answers. From sourcing products, materials, and services to expanding your reach and visibility, the platform helps you search smarter and connect with the right people. In addition, the platform enables personal users to access curated resources, stay updated on industry events, explore career and hiring opportunities, and review businesses and firms. Archinza also offers AI-matched upskilling courses making it a one-stop platform for knowledge, discovery, and growth.",
  },
  {
    title: "Who is Archinza for?",
    content:
      "Archinza is designed for anyone seeking information or connections in the Design & Build industry. Whether you're a creative professional (designer, architect, content creator), a service provider (business owner, contractor, vendor, PR or marketing professional), a material or product seller/distributor, or simply someone passionate about the industry, Archinza is here to empower your journey at every stage.",
  },
  {
    title: `What is the "Ask" feature in Archinza?`,
    content:
      "The Ask feature is powered by AI and provides instant, relevant answers to your design and construction questions whether it’s about materials, methods, or project tips. Just type your query, and get immediate answers!",
  },
  {
    title: "Can I ask my design & construction related queries on Archinza?",
    content: `Yes, you can! Archinza is for anyone curious about design and construction. Just use the <b>Ask</b> feature on <b>WhatsApp</b> to get quick, easy answers on materials, finishes, lighting, or simply understanding how things work.
`,
  },
  {
    title: "Can I search for design materials or products on Archinza?",
    content: `Yes, Archinza allows you to explore a wide range of design materials and products through text or image-based search. Simply enter what you need or upload a photo, and the platform will help you discover relevant options that match your style or intent.`,
  },
  {
    title: "Where do I sign up? ",
    // content: `<a href='${accountCategoryURL}' class='anchor'>Click here</a> to get free access to the Archinza Network.<br />Archinza offers free access to its features for the first 500 users.`,
    content: `<a href='${accountCategoryURL}' class='anchor'>Click here</a>  to be a part of the Archinza Network.
`,
  },
  {
    title: "Is Archinza free?",
    // content: `<a href='${accountCategoryURL}' class='anchor'>Click here</a> to get free access to the Archinza Network.<br />Archinza offers free access to its features for the first 500 users.`,
    content: `Archinza is currently free for personal accounts during our limited early access phase available only until the full product launch. After that, subscription plans will range between ₹999 and ₹2999, depending on your account type and selected features.`,
  },
];

export const busBenefitsData = [
  "Get found by clients looking for you",
  "Generate High Quality Business Leads",
  "Hire for your Business/Firm",
  "Showcase Products & Services",
  // "Access to Design Events",
  "Updates about Design events",
];
